// extracted by mini-css-extract-plugin
export default {"layout":"_472aacc91f fdb3d7f541 d641d9ae86","h_slide":"_4a9a58d6e5","category":"acf6eb0674 _491366d00d _7b31c27b12"};